import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Search, MessageCircle } from "lucide-react";
import { useSettings } from "../lib/settings";
import { track } from "../lib/analytics";

const NAV = [
  { label: "Privati", to: "/privati-famiglie" },
  { label: "Imprese & Professionisti", to: "/imprese-societa" },
  { label: "Casa & Locazioni", to: "/casa-locazioni" },
  { label: "Lavoro domestico", to: "/lavoro-domestico" },
  { label: "Pensioni & Patronato", to: "/pensioni-previdenza" },
  { label: "Servizi digitali", to: "/servizi-digitali" },
  { label: "Strumenti", to: "/strumenti" },
  { label: "Come funziona", to: "/#come-funziona" },
  { label: "Chi siamo", to: "/chi-siamo" },
  { label: "FLASH Plus", to: "/flash-plus" },
  { label: "Area clienti", to: "/area-clienti" },
];

export const Header = ({ onSearch }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { waLink } = useSettings();
  const wa = waLink();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="header-navigation"
      className={`fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-[#E7E7E7] transition-all duration-300 ${
        scrolled ? "shadow-[0_2px_20px_rgba(0,0,0,0.06)]" : ""
      }`}
    >
      <div
        className={`max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between gap-4 transition-all duration-300 ${
          scrolled ? "h-14" : "h-[72px]"
        }`}
      >
        <Link to="/" data-testid="brand-logo-link" className="flex items-center shrink-0">
          <img src="/logo-light.png" alt="FLASH Service & Consulting" width="160" height="44" fetchPriority="high" className={`w-auto transition-all duration-300 ${scrolled ? "h-9" : "h-11"}`} />
        </Link>

        <nav className="hidden xl:flex items-center gap-5">
          {NAV.map((l) => {
            const cls = "text-[13px] font-medium text-[#4B4B4B] hover:text-[#F26522] transition-colors whitespace-nowrap";
            const tid = `nav-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
            // <a href> reali (non button): la nav principale deve essere crawlable da Google
            return l.to.startsWith("/#") ? (
              <Link key={l.label} to="/" data-testid={tid} onClick={() => setTimeout(() => document.querySelector(l.to.slice(1))?.scrollIntoView({ behavior: "smooth" }), 100)} className={cls}>{l.label}</Link>
            ) : (
              <Link key={l.label} to={l.to} data-testid={tid} className={cls}>{l.label}</Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2">
          <button
            data-testid="nav-search-button"
            onClick={onSearch}
            aria-label="Cerca un servizio"
            className="p-2.5 rounded-full text-[#4B4B4B] hover:bg-[#F5F5F5] hover:text-[#F26522] transition-colors"
          >
            <Search size={19} />
          </button>
          {wa && (
            <a
              data-testid="nav-whatsapp-button"
              href={wa}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track("whatsapp_click", { placement: "header" })}
              aria-label="WhatsApp"
              className="hidden sm:flex p-2.5 rounded-full text-[#25D366] hover:bg-[#F5F5F5] transition-colors"
            >
              <MessageCircle size={19} />
            </a>
          )}
          <Link
            to="/prenota"
            data-testid="nav-cta-prenota-button"
            className="hidden sm:inline-flex items-center bg-[#F26522] hover:bg-[#D94E0F] text-white text-sm font-semibold rounded-full px-5 py-2.5 transition-colors"
          >
            Prenota appuntamento
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
            className="xl:hidden p-2.5 rounded-full text-[#171717] hover:bg-[#F5F5F5]"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="xl:hidden bg-white border-t border-[#E7E7E7] shadow-lg">
          <div className="px-5 py-3 flex flex-col max-h-[70vh] overflow-y-auto">
            {NAV.map((l) => {
              const cls = "text-left py-3.5 text-[15px] font-medium text-[#171717] border-b border-[#F0F0F0] last:border-0 block";
              const tid = `mobile-nav-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
              return l.to.startsWith("/#") ? (
                <Link key={l.label} to="/" data-testid={tid} onClick={() => { setOpen(false); setTimeout(() => document.querySelector(l.to.slice(1))?.scrollIntoView({ behavior: "smooth" }), 100); }} className={cls}>{l.label}</Link>
              ) : (
                <Link key={l.label} to={l.to} data-testid={tid} onClick={() => setOpen(false)} className={cls}>{l.label}</Link>
              );
            })}
            <Link
              to="/prenota"
              data-testid="mobile-nav-cta-prenota"
              onClick={() => setOpen(false)}
              className="mt-3 mb-3 text-center bg-[#F26522] text-white font-semibold rounded-full px-5 py-3.5"
            >
              Prenota appuntamento
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
